/*
 * Copyright (C) 2007 - 2014 Hyperweb2 All rights reserved.
 * GNU General Public License version 3; see www.hyperweb2.com/terms/
 */

'use strict';

define([
   "hwc_js_kernel_loader"
],function () {

});


//////////////////
// WEBPACK FOOTER
// ./modules/hw-core/js-lib-class/include.js
// module id = 22
// module chunks = 0